<script>
  export default{
    name: 'chat-comitente-resumido',
    props: ['comConnected'],
    data () {
      return {}
    },
    computed: {},
    mounted () {
    },
    destroyed () {
    },
    methods: {},
    components: {}
  }
</script>

<template>
  <div class="chat-resumido-comitente sys-table" :class="{'bg-danger': comConnected === 2}">
    <div class="chat-content">
      <!--<div class="message">
        <strong>AZULSEGUROS</strong> Poderia retornar o leilão do lote 027,
        pois o valor mínimo rejeitado inicialmente foi aprovado pela diretoria. <span>12 segundos atrás</span>
      </div>-->
      <div class="message0 no-select">
        Nenhuma mensagem
      </div>
      <div class="message0 no-select" v-if="comConnected === 2">
        <span class="text-danger">Comunicação RealTime com problemas. Tentando reconectar</span>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// ChatResumidoComitente.vue?526c306c